import { useContext, useEffect, useState } from 'react';
import {  Modal } from 'react-bootstrap';
import { FaAddressCard } from 'react-icons/fa';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { UpdateSituationAPI } from '../../API/CompaniesAPI';
import { CompanyContext } from '../../Contexts/CompanyContext';
import { IResponseProps } from '../../Interfaces/IResponseProps';
import { ISelectProps } from '../../Interfaces/ISelectProps';
import { AllStatus } from '../../Utils/AllContratTypes';
import { AllSteps } from '../../Utils/AllSteps';
import './styles.css';
import useCan from '../../Hooks/useCan';
import { ProjectHistoryModel } from '../../Models/ProjectHistoryModel';
import {Button, TextField } from '@mui/material';

interface IModalProjectProps {
    showModal: boolean,
    toggleShowModal: () => void,
    projectItem: ProjectHistoryModel
}



const ModalProject = (props: IModalProjectProps) => {

    const canView = useCan({ rolesCan: ["Manager", "Consultant"] });
    const { company, getCompany } = useContext(CompanyContext);

    return (
        <Modal show={props.showModal} onHide={props.toggleShowModal}>
            <Modal.Header closeButton>
                <Modal.Title className='d-flex align-items-center fw-bold'>
                    {props.projectItem.name}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <h6 className='fw-bold'>Atividades Associadas ao Projeto</h6>
                    <TextField multiline minRows={1} disabled={true} className="h-100 w-100"
                        value={props.projectItem.activities}
                    />
                </div>
                <h6 className='py-3 fw-bold'>Orçamento do Projeto</h6>
                <div className='d-flex justify-content-between align-items-center bg-light'>
                    <h6 className='p-2 ms-3 m-0'>Orçamento Total</h6>
                    <h6 className='p-2 me-3 m-0'>{"R$ " + new Intl.NumberFormat("pt-BR", {
                        minimumFractionDigits: 2,
                    }).format(props.projectItem.budget)}</h6>
                </div>
            </Modal.Body>
            {canView &&
                <Modal.Footer>
                    <Button variant='contained' color='secondary' className='btn btn-primary w-100' onClick={props.toggleShowModal}>
                        Fechar
                    </Button>
                </Modal.Footer>
            }
        </Modal>
    )
}

export default ModalProject;